import React from 'react';
import { CarouselCellFragment } from '../../generated/types/CarouselCellFragment';
import { useModuleTracking } from '../../hooks/useModuleTracking';
import { NormalizePumoStyles } from '../NormalizePumoStyles';
import { DividerModule, DividerModuleProps } from '../DividerPumoModule';
import { CAROUSEL_DEFAULT_CONFIG, SwiperCarousel } from '../Swiper';
import { CarouselCell } from '../Grid';

import './RecommendationsCarousel.scss';

interface Props {
  loading: boolean;
  error: Error | undefined;
  divider: DividerModuleProps;
  cells: CarouselCellFragment[];
  identifier: string;
}

export const RecommendationsCarousel: React.FC<Props> = ({
  loading,
  error,
  divider,
  cells,
  identifier
}) => {
  const { ref, onClick } = useModuleTracking({ name: divider.text, attachClickHandler: false });

  if (loading || error || cells.length === 0) return null;

  return (
    <div ref={ref}>
      <NormalizePumoStyles className="RecommendationsCarousel">
        <DividerModule {...divider} />
      </NormalizePumoStyles>

      <SwiperCarousel
        identifier={identifier}
        {...CAROUSEL_DEFAULT_CONFIG}
        onClick={(swiper, event) => onClick(event)}
      >
        {cells.map((carouselCell, i) => (
          <CarouselCell key={i} carouselCell={carouselCell} moduleName={divider.text} />
        ))}
      </SwiperCarousel>
    </div>
  );
};
